// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Action from 'core/fsmpack/statemachine/actions/Action';

/**
 * @autodoc apply FsmAction
 */
class SetAnimationAction extends Action {

  constructor(options) {
    super(...arguments); // also support (id, settings) parameters used with FSM
    this._transitioned = false;
    this._currentState = null;
    this._previousLoop = 0;
  }

  static getTransitionLabel(transitionKey /* , actionConfig */) {
    return labels[transitionKey];
  }

  enter() {
    this._transitioned = false;
    this._currentState = null;
    this._previousLoop = 0;
  }

  update(fsm) {
    // If we already made the transition, bail
    if (this._transitioned) {
      return;
    }

    const entity = fsm.getOwnerEntity();
    const that = this;

    if (this.animation && entity.animationComponent && entity.animationComponent.getStateById(this.animation)) {

      if (this._currentState === null) { // First enter!
        // Set the animation
        entity.animationComponent.transitionTo(this.animation, true);

        // Set the current state for the action
        this._currentState = entity.animationComponent.getStateById(this.animation);
      } else {
        if (this._currentState.getCurrentLoop() + this._previousLoop === this.loops) {
          fsm.send(that.transitions.complete);
          this._transitioned = true;
        } else if (!entity.animationComponent.getCurrentState()) {
          // Reset the animation for the animations that don't play infinitely
          entity.animationComponent.transitionTo(this.animation, true);
          this._previousLoop += this._currentState.getCurrentLoop();
        }
      }
    }
  }

  exit() {
    this._transitioned = false;
    this._currentState = null;
    this._previousLoop = 0;
  }
}

SetAnimationAction.external = {
  key: 'SetAnimation',
  deprecatedKey: 'Set Animation',
  name: 'Set Animation',
  type: 'animation',
  description: "Transitions to a selected skeleton animation in the Animation Asset used on the behavior's Animation Component.",
  parameters: [{
    name: 'Animation',
    key: 'animation',
    description: 'Animation to be set.',
    type: 'animstate',
  }, {
    name: 'Loops',
    key: 'loops',
    description: 'How many times to loop before transitioning.',
    type: 'int',
    min: 1,
    default: 1,
  }],
  transitions: [{
    key: 'complete',
    description: 'State to transition to when the target animation completes. If the animation loops forever, the transition will be done when the next loop starts.',
  }],
};

const labels = {
  complete: 'On animation complete',
};

SetAnimationAction.register();

export default SetAnimationAction;
